import { colorsDark } from '../../themes';

export const menuDarkTheme = {
  inlineWhitespace: '8px',
  background: colorsDark.gray[0],
  borderColor: colorsDark.gray[300],
  item_divider_color: colorsDark.gray[200],
  item_color: colorsDark.royalBlue[1000],
  item_background: 'transparent',
  item_active_color: colorsDark.royalBlue[1000],
  item_active_background: colorsDark.blue[200],
  item_hover_color: colorsDark.royalBlue[1000],
  item_hover_background: colorsDark.gray[300],
  item_disabled_color: colorsDark.gray[500],
  item_disabled_background: 'transparent',
  icon_color: colorsDark.royalBlue[1000],
};
